import liyue from "assets/area/liyue.png";

export default {
  liyue
};
